import { render, staticRenderFns } from "./reach-potential.vue?vue&type=template&id=0f0fe76e&"
import script from "./reach-potential.vue?vue&type=script&lang=js&"
export * from "./reach-potential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports